<template>
  <CContainer>
    <CRow>
      <CCol col="12" sm="12">
        <CCard>
          <CCardBody>
            <CRow>
              <CCol col="12" sm="3">
                <CustomerQuantityIndicatorPanel
                    typeIndicator="TO"
                    :initialDate="fechaInicial" 
                    :finalDate="fechaFinal" 
                    :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                    :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null">
                </CustomerQuantityIndicatorPanel>
              </CCol>
              <CCol col="12" sm="3">
                <CustomerQuantityIndicatorPanel
                    typeIndicator="AC"
                    :initialDate="fechaInicial" 
                    :finalDate="fechaFinal" 
                    :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                    :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null">
                </CustomerQuantityIndicatorPanel>
              </CCol>
              <CCol col="6" sm="3">
                <CustomerQuantityIndicatorPanel
                    typeIndicator="MO"
                    :initialDate="fechaInicial" 
                    :finalDate="fechaFinal" 
                    :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                    :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null">
                </CustomerQuantityIndicatorPanel>
              </CCol>
              <CCol col="6" sm="3">
                <CustomerQuantityIndicatorPanel
                    typeIndicator="SU"
                    :initialDate="fechaInicial" 
                    :finalDate="fechaFinal" 
                    :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                    :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null">
                </CustomerQuantityIndicatorPanel>
              </CCol>
              <CCol col="12" sm="3">
                <CustomerQuantityIndicatorPanel 
                  typeIndicator="CA"
                  :initialDate="fechaInicial" 
                  :finalDate="fechaFinal" 
                  :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                  :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null">
                </CustomerQuantityIndicatorPanel>
              </CCol>
              <CCol col="6" sm="3">
                <CustomerQuantityIndicatorPanel 
                  typeIndicator="CN"
                  :initialDate="fechaInicial" 
                  :finalDate="fechaFinal" 
                  :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                  :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null">
                </CustomerQuantityIndicatorPanel>
              </CCol>
              <CCol col="6" sm="3">
                <CustomerQuantityIndicatorPanel 
                  typeIndicator="CP"
                  :initialDate="fechaInicial" 
                  :finalDate="fechaFinal" 
                  :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                  :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null">
                </CustomerQuantityIndicatorPanel>
              </CCol>
              <CCol col="6" sm="3">
                <CustomerQuantityIndicatorPanel 
                  typeIndicator="PN"
                  :initialDate="fechaInicial" 
                  :finalDate="fechaFinal" 
                  :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                  :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null">
                </CustomerQuantityIndicatorPanel>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </CContainer>
</template>
<script>
  // import { defineComponent } from '@vue/composition-api'
  import moment from "moment";

  import CustomerQuantityIndicatorPanel from "../../components/panels/CustomerQuantityIndicatorPanel.vue";

  export default {
    name: "DashboardCustomer",
    setup() {

    },
    data() {
      return {
        fechaInicial: 0,
        fechaFinal: 0
      }
    },
    components: {
        CustomerQuantityIndicatorPanel
    },
    methods: {

    },
    computed: {

    },
    created() {
      this.fechaInicial = moment().startOf("month").format("YYYY-MM-DD");
      this.fechaFinal = moment().format("YYYY-MM-DD");
    },
    mounted() {

    }
  }
</script>
